// extracted by mini-css-extract-plugin
module.exports = {"string-to-svg":"StringToSvg_string-to-svg__38vlD"};